import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const LinkedinScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M20.4006 2H3.70878C2.79708 2 2 2.65642 2 3.5577V20.286C2 21.1925 2.79708 22 3.70878 22H20.3954C21.3123 22 22 21.1873 22 20.286V3.5577C22.0052 2.65642 21.3123 2 20.4006 2ZM8.19952 18.671H5.3342V9.76243H8.19952V18.671ZM6.86584 8.40791H6.845C5.9281 8.40791 5.3342 7.72544 5.3342 6.87105C5.3342 6.00104 5.94373 5.3342 6.88147 5.3342C7.81922 5.3342 8.39228 5.99583 8.41312 6.87105C8.41312 7.72544 7.81921 8.40791 6.86584 8.40791ZM18.671 18.671H15.8057V13.7999C15.8057 12.633 15.3889 11.8359 14.3522 11.8359C13.5603 11.8359 13.0914 12.3725 12.883 12.8934C12.8049 13.081 12.784 13.3363 12.784 13.5968V18.671H9.91872V9.76243H12.784V11.0023C13.2008 10.4084 13.852 9.55404 15.368 9.55404C17.2487 9.55404 18.671 10.7939 18.671 13.4665V18.671Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Linkedin'
);
export default LinkedinScaleMediumAppearanceDefault;
